import {FC} from 'react'
import QRCode from 'react-qr-code'

interface IQrCodeProps {
  bgColor?: string
  fgColor?: string
  level?: string
  size?: number
  url: string
  gameCode?: string
}

export const QrCode: FC<IQrCodeProps> = ({
  bgColor = '#FFFFFF',
  fgColor = '#000000',
  level = 'L',
  size = 264,
  url,
  gameCode,
}) => {
  let constructedUrl = url

  if (gameCode) {
    constructedUrl = `${url}?gameCode=${gameCode}`
  }

  if (!constructedUrl.startsWith('http') || !constructedUrl.startsWith('https')) {
    constructedUrl = `https://${constructedUrl}`
  }

  return (
    <QRCode
      bgColor={bgColor}
      fgColor={fgColor}
      level={level}
      size={size}
      value={constructedUrl}
      id="game-qr-code"
    />
  )
}
